import {
    useEffect,
    useRef
} from 'react'
import { useFormContext } from 'react-hook-form'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import RefreshIcon from '@mui/icons-material/Refresh'
import SignaturePad from 'react-signature-canvas'

import dataURLtoFile from '@shared/utils/urlToFile'

export default function Signature() {
    const padRef = useRef(null)
    const {
        setValue,
        watch
    } = useFormContext()
    const supervisorSignature = watch('supervisor_signature')

    const handleSet = () => {
        const file = dataURLtoFile(padRef.current.toDataURL())

        Object.defineProperty(file, '_id', {
            value: Date.now(),
            enumerable: true,
        })

        setValue(
            'supervisor_signature',
            file,
            { shouldDirty: true }
        )
    }

    const handleReset = () => {
        padRef.current.clear()
        setValue('supervisor_signature', '')
    }

    useEffect(() => {
        if (!padRef.current || !supervisorSignature) return

        const canvas = padRef.current.getCanvas()
        const ctx = canvas.getContext('2d')

        const img = new Image()
        img.crossOrigin = 'anonymous'

        img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        }

        if (typeof supervisorSignature === 'string') {
            const isDataUrl = supervisorSignature.startsWith('data:') || supervisorSignature.startsWith('blob:')

            img.src = isDataUrl
                ? supervisorSignature
                : `${supervisorSignature}?cb=${new Date().getTime()}`

        } else if (supervisorSignature instanceof File || supervisorSignature instanceof Blob) {
            img.src = URL.createObjectURL(supervisorSignature)
        }
    }, [supervisorSignature])

    return (
        <div style={{
            width: '100%',
            overflow: 'hidden'
        }}>
            <Box sx={{
                mb: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Typography variant='body2'>توقيع المشرف</Typography>
                <IconButton size='small' onClick={handleReset}>
                    <RefreshIcon />
                </IconButton>
            </Box>
            <Box sx={{
                width: '100%',
                overflow: 'hidden',
                border: '1px solid #ccc',
                borderRadius: '8px'
            }}>
                <SignaturePad
                    ref={padRef}
                    onEnd={handleSet}
                    canvasProps={{
                        width: 390,
                        height: 100,
                    }}
                    clearOnResize={false}
                    minWidth={1.5}
                    maxWidth={4}
                />
            </Box>
        </div>
    )
}